import React from "react";


export const QuestionB2Parts = () => {

    return (
        <div className="select_desc mb-70">
            ■ガス機器購入コース<br/>
            ■LPガスご利用コース<br/>
            に応募します
        </div>
    )
}